import React from 'react';
import { FileText, FilePlus, MessageSquare, Sparkles, X } from 'lucide-react';
import { PortalChip } from '../arkorbit-ui/PortalChip';
import type { WebArticleFetchResult } from './arkoWebArticle';

export type WebArticleActionId = 'summarize' | 'show_full' | 'new_document' | 'continue' | 'cancel';

interface ArkoWebArticleActionsProps {
  article: WebArticleFetchResult;
  disabled?: boolean;
  hasOpenDocument?: boolean;
  onAction: (action: WebArticleActionId) => void;
}

const ACTIONS: Array<{
  id: WebArticleActionId;
  label: string;
  icon: React.ElementType;
  variant?: 'primary';
}> = [
  { id: 'summarize', label: 'Zusammenfassen', icon: Sparkles, variant: 'primary' },
  { id: 'show_full', label: 'Volltext anzeigen', icon: FileText },
  { id: 'new_document', label: 'In neues Dokument', icon: FilePlus },
  { id: 'continue', label: 'Weiterarbeiten', icon: MessageSquare },
  { id: 'cancel', label: 'Abbrechen', icon: X },
];

export function ArkoWebArticleActions({
  article,
  disabled = false,
  hasOpenDocument = false,
  onAction,
}: ArkoWebArticleActionsProps) {
  return (
    <div className="flex flex-col gap-2 w-full max-w-[min(100%,32rem)]">
      <div className="text-[11px] text-slate-400 border border-slate-700/60 rounded-lg px-3 py-2 bg-slate-900/40">
        <span className="text-emerald-400/90 font-medium">Quelle:</span>{' '}
        {article.host}
        {article.title ? (
          <>
            <span className="text-slate-600 mx-1">·</span>
            <span className="text-slate-300">{article.title}</span>
          </>
        ) : null}
        {article.paywall_hint ? (
          <p className="mt-1 text-amber-400/80">{article.paywall_hint}</p>
        ) : null}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {ACTIONS.map((action) => (
          <PortalChip
            key={action.id}
            label={action.label}
            icon={action.icon}
            disabled={disabled}
            onClick={() => onAction(action.id)}
            accent={action.variant === 'primary' ? 'emerald' : 'blue'}
          />
        ))}
      </div>
      {hasOpenDocument ? (
        <p className="text-[10px] text-slate-500">
          „In neues Dokument" legt einen Synthese-Entwurf an; mit geöffnetem Dokument können Sie auch „Weiterarbeiten" nutzen.
        </p>
      ) : null}
    </div>
  );
}
